var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { forEach } from "lodash-es";
import { createPopper } from '@popperjs/core';
var DropdownMenu = /** @class */ (function () {
    function DropdownMenu(selector, options) {
        if (options === void 0) { options = { placement: 'bottom-start', modifiers: [], strategy: 'absolute' }; }
        var _this = this;
        document.addEventListener('DOMContentLoaded', function () {
            forEach(document.querySelectorAll('[data-hover-toggle]'), function (triggerElement) {
                var targetQuery = '#' + triggerElement.dataset.hoverToggle;
                var targetElement = document.querySelector(targetQuery);
                if (!targetElement)
                    return;
                var linkElement = triggerElement.querySelector('a');
                var subMenuLinks = targetElement.querySelectorAll('a');
                var lastLinkInMenu = subMenuLinks[subMenuLinks.length - 1];
                // Focus events
                if (linkElement) {
                    linkElement.addEventListener('focus', function () {
                        _this.onSubMenuOpen(triggerElement, targetElement, options);
                    });
                    // If tabbed backwards, the menu should hide
                    linkElement.addEventListener('blur', function () {
                        requestAnimationFrame(function () {
                            if (!targetElement.contains(document.activeElement)) {
                                _this.onSubMenuClose(targetElement, options);
                            }
                        });
                    });
                }
                if (lastLinkInMenu) {
                    __spreadArray([lastLinkInMenu], Array.from(targetElement.querySelectorAll('a')), true).forEach(function (element) {
                        element.addEventListener('blur', function () {
                            requestAnimationFrame(function () {
                                if (document.activeElement !== linkElement && !targetElement.contains(document.activeElement)) {
                                    _this.onSubMenuClose(targetElement, options);
                                }
                            });
                        });
                    });
                }
                // Mouse events
                triggerElement.addEventListener('mouseover', function () {
                    _this.onSubMenuOpen(triggerElement, targetElement, options);
                });
                triggerElement.addEventListener('mouseleave', function () {
                    _this.onSubMenuClose(targetElement, options);
                });
            });
            // Click-only toggles
            forEach(document.querySelectorAll('[data-toggle]'), function (triggerElement) {
                triggerElement.addEventListener('click', function (event) {
                    var _a;
                    var targetElement = document.getElementById((_a = triggerElement.dataset.toggle) !== null && _a !== void 0 ? _a : '');
                    var openIconElement = triggerElement.querySelector('.open-icon');
                    var closeIconElement = triggerElement.querySelector('.close-icon');
                    if (!targetElement)
                        return;
                    if (targetElement.classList.contains('active')) {
                        triggerElement.setAttribute('aria-expanded', 'false');
                        triggerElement.classList.remove('active');
                        targetElement.classList.remove('active');
                        if (triggerElement.getAttribute('aria-label') === 'Close main menu') {
                            triggerElement.setAttribute('aria-label', 'Open main menu');
                        }
                        if (openIconElement && openIconElement.classList.contains('d-none')) {
                            openIconElement.classList.remove('d-none');
                        }
                        if (closeIconElement) {
                            closeIconElement.classList.add('d-none');
                        }
                    }
                    else {
                        triggerElement.setAttribute('aria-expanded', 'true');
                        triggerElement.classList.add('active');
                        targetElement.classList.add('active');
                        if (triggerElement.getAttribute('aria-label') === 'Open main menu') {
                            triggerElement.setAttribute('aria-label', 'Close main menu');
                        }
                        if (closeIconElement && closeIconElement.classList.contains('d-none')) {
                            closeIconElement.classList.remove('d-none');
                        }
                        if (openIconElement) {
                            openIconElement.classList.add('d-none');
                        }
                    }
                });
            });
        });
    }
    DropdownMenu.prototype.onSubMenuOpen = function (triggerElement, targetElement, options) {
        delete targetElement.dataset.hide;
        targetElement.classList.add('show');
        createPopper(triggerElement, targetElement, options);
    };
    DropdownMenu.prototype.onSubMenuClose = function (targetElement, options) {
        targetElement.dataset.hide = 'hide';
        setTimeout(function () {
            if (targetElement.dataset.hide) {
                targetElement.classList.remove('show');
            }
        }, 50);
    };
    return DropdownMenu;
}());
export { DropdownMenu };
